/**
 * @generated SignedSource<<575237eb5c039abf0810a572b4b54219>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RowMaybeWithDragAndDrop_project" | "RowWithSiblingCreate_project">;
  readonly " $fragmentType": "Row_project";
};
export type Row_project$key = {
  readonly " $data"?: Row_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row_project">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isConditionalFormattingEnabled",
    "variableName": "isConditionalFormattingEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Row_project",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowMaybeWithDragAndDrop_project"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowWithSiblingCreate_project"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "29bc757a62493204a08d7359797abc9b";

export default node;
